<dynamic-form
  *ngIf="columns && columns.length"
  [apiName]="apiName"
  [label]="label"
  [group]="formGroup"
  [areaName]="areaName"
  [model]="model"
  [columns]="columns"
  (cancelChange)="cancel()"
  (submitChange)="save()">
  <ng-container class="content">
    <div class="sublegerTitle" *ngIf="currentrow" style="position: absolute; top: 0; right: 50%; transform: translate(50%, 0%); width: 100%">
      {{ model.SubLedgerTypeTitle }}
    </div>
  </ng-container>
</dynamic-form>
